module.exports = __webpack_public_path__ + "fonts/Inter-200-cyrillic30.06ab411.woff2";